import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  table: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(8),
    maxWidth: theme.spacing(80),
    '& .MuiTableCell-body': {
      color: theme.palette.neutral.dark,
      fontFamily: 'ActoMedium',
      fontSize: 16,
      lineHeight: theme.spacing(3),
      '&.truncate span': {
        width: '28ch',
      },
    },
  },
}))

export default useStyles
